<template lang="pug">
MakerAdminLayout(accountPageHeading="Manage company")
   Panel(v-if="showPanel" :panelProps="{...panelProps}" @cancel="companyPanelCancel" @done="companyPanelDone")
   ._mb4(v-if="company && company.data")
      //- ----------------------------------------------------------------
      //- Company overview
      //- ----------------------------------------------------------------
      ._mb3
         AccountPanelHeading(heading="Company account overview")
         ._border._bg-white._boxShadow._radius._pb1-5(v-if="company")
            div(v-if="!editMode")
               ._flex._flex-alignItemsCenter._px1-5._pt1-5
                  ._c-grey-600(style="width: 150px;") Name:
                  ._bold._c-grey-700 {{company.data.name}}
               ._flex._flex-alignItemsCenter._px1-5._pt1-5
                  ._c-grey-600(style="width: 150px;") Created:
                  ._bold._c-grey-700 {{company.data.createdAt | defaultDateTime}}
               ._flex._flex-alignItemsCenter._px1-5._pt1-5(v-if="company.data.createdAt !== company.ts")
                  ._c-grey-600(style="width: 150px;") Last updated:
                  ._bold._c-grey-700 {{company.ts | defaultDateTime}}
               //- ._mt2._px1-5
                  button.Btn.Btn--white.Btn--sm(type="button" v-on:click="editTeamInfo('ref-teamNameInput')") Edit team info
            //- form(v-if="editMode" @submit.prevent="handleSubmit")
               div
                  label.Label._flex._flex-alignItemsCenter._pl2._pr075._pt075
                     .LabelText._mb0._c-grey-700(style="width: 200px") Team name:
                     input.Input(ref="ref-teamNameInput" type="text" v-model.trim="teamInfoFormState.name || team.data.name")
               div
                  label.Label._flex._flex-alignItemsCenter._pl2._pr075._pt075
                     .LabelText._mb0._c-grey-700(style="width: 200px") Company name:
                     input.Input(type="text" v-model.trim="teamInfoFormState.nameCompany || team.data.nameCompany")
               ._mt2._px1-5
                  button.Btn.Btn--green._px3._mr1(type="submit") Save
                  button.Btn.Btn--white(type="button" v-on:click="editMode = false") Cancel
      ._mb3
         AccountPanelHeading(heading="Company info")
         ._relative._border._bg-white._boxShadow._radius._pb1-5(v-if="company")
            Loading(v-if="isSaving && savingPanelRef === 'ref-info'")
            div
               ._flex._flex-alignItemsCenter._px1-5._pt1-5
                  ._c-grey-600._flex-noShrink(style="width: 150px;") Logo:
                  ._bold._c-grey-700: ._c-grey-300 TODO
               ._flex._flex-alignItemsCenter._px1-5._pt1-5
                  ._c-grey-600._flex-noShrink(style="width: 150px;") Tagline:
                  ._bold._c-grey-700 {{company.data.tagline}}
               ._flex._flex-alignItemsCenter._px1-5._pt1-5
                  ._c-grey-600._flex-noShrink(style="width: 150px;") Summary:
                  ._bold._c-grey-700 {{company.data.summary}}
               ._mt2._px1-5
                  button.Btn.Btn--white.Btn--sm(type="button" v-on:click="companyPanelEdit({ref: 'ref-info', heading: 'Company info'})") Edit
            //- form(v-if="editMode" @submit.prevent="handleSubmit")
               div
                  label.Label._flex._flex-alignItemsCenter._pl2._pr075._pt075
                     .LabelText._mb0._c-grey-700(style="width: 200px") Team name:
                     input.Input(ref="ref-teamNameInput" type="text" v-model.trim="teamInfoFormState.name || team.data.name")
               div
                  label.Label._flex._flex-alignItemsCenter._pl2._pr075._pt075
                     .LabelText._mb0._c-grey-700(style="width: 200px") Company name:
                     input.Input(type="text" v-model.trim="teamInfoFormState.nameCompany || team.data.nameCompany")
               ._mt2._px1-5
                  button.Btn.Btn--green._px3._mr1(type="submit") Save
                  button.Btn.Btn--white(type="button" v-on:click="editMode = false") Cancel
      ._mb3
         AccountPanelHeading(heading="Teams")
         ._border._bg-white._boxShadow._radius._pb1-5(v-if="company")
            router-link.TeamItem._block._borderBottom-default._borderColor-grey-200._py1-5(v-for="teamProfile in company.teamProfilesResolved" v-bind:key="teamProfile.teamResolved.ref.id" :to="`/${teamProfile.data.slug.current}/manage/`")
               ._flex._px1-5._mb1
                  ._c-grey-600 Team: 
                  ._ml1._bold._c-grey-700 {{teamProfile.teamResolved.data.name}}
               ._fs-075._flex._px1-5
                  ._c-grey-600 Added: 
                  ._ml1 {{teamProfile.teamResolved.data.createdAt | defaultDateTime}}
            ._mt1-5._px1-5
               button.Btn.Btn--white.Btn--sm(type="button" @click="handleAddTeamClick()")
                  ._flex._flex-alignItemsCenter
                     ._fs-3._mr1 +
                     div Add team

      //- //- ----------------------------------------------------------------
      //- //- Danger zone
      //- //- ----------------------------------------------------------------
      //- div
      //-    AccountPanelHeading(heading="Delete team")
      //-    ._border._bg-white._boxShadow._radius._pb2   
      //-       ._pt2._px1-5
      //-          ._c-grey-600._mb075 
      //-             | This 
      //-             span._bold cannot 
      //-             | be undone.
      //-          ._c-grey-600 
      //-             | Deleting your team will delete its account and profile. This will not delete 
      //-             span._italic your 
      //-             | account.
      //-       ._mt2._px1-5
      //-          button.Btn.Btn--red.Btn--sm(type="button" @click="showDeleteTeamConfirmation()") Delete team
</template>

<style lang="sass" scoped>
.TeamItem
   text-decoration: none
   color: $grey-700
   &:hover,
   &:focus
      background-color: $grey-050
      color: $grey-800
</style>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import MakerAdminLayout from '~/layouts/MakerAdmin.vue'
import AccountPanelHeading from '~/components/AccountPanelHeading.vue'
import * as faunaQueries from '~/faunaQueries.js'
import Panel from '~/components/companyEdit-Panel'
import { cloneDeep } from 'lodash'

export default {
   components: {
      MakerAdminLayout,
      AccountPanelHeading,
      Panel,
   },
   data() {
      return {
         // -------------------------------
         // edit panel
         Panel: Panel,
         showPanel: false,
         panelProps: undefined,
         // -------------------------------
         isSaving: false,
         savingPanelRef: undefined,
         editMode: false,
         isMakersLoading: false,
         companySlug: this.$route.params.companySlug,
         company: undefined,
      }
   },
   computed: {
      ...mapState(['makerState']),
   },
   methods: {
      handleAddTeamClick() {
         const data = {
            company: {
               ref: this.company.ref,
            },
         }
         return this.$store.dispatch('updateNewTeamTempState', data).then(() => this.$router.push('/add-team/step-2'))
      },
      handleMounted() {
         this.company = this.$store.getters.getCompanyBySlug(this.companySlug)
      },
      companyPanelEdit({ ref, heading }) {
         const clondedCompanyData = cloneDeep(this.company.data)
         console.log(clondedCompanyData)
         // const itemsForPanel = directlyEditProfileEditObj ? items : items.map(item => cloneDeep(item))

         this.panelProps = { ref, heading, companyData: clondedCompanyData }
         this.showPanel = true
      },
      companyPanelCancel() {
         this.showPanel = false
      },
      companyPanelDone({ ref, companyData }) {
         this.isSaving = true
         this.savingPanelRef = ref
         // TODOs:
         // - [ ] Show loading indicator
         // - [ ] Ensure changes show up
         // - [ ] Handle setting this stuff in onboarding process

         this.showPanel = false
         let updateData
         if (ref === 'ref-info') {
            updateData = {
               summary: companyData.summary,
               tagline: companyData.tagline,
            }
         }

         this.$store
            .dispatch('updateCompanyData', {
               companyRef: this.company.ref,
               updateData,
            })
            .then(() => {
               this.isSaving = false
               this.savingPanelRef = undefined
               this.company = this.$store.getters.getCompanyBySlug(this.companySlug)
            })
      },
   },
   mounted() {
      this.company = this.$store.getters.getCompanyBySlug(this.companySlug)
   },
   beforeRouteUpdate(to, from, next) {
      // Force the component to re-render.
      // https://router.vuejs.org/guide/essentials/dynamic-matching.html#reacting-to-params-changes
      this.companySlug = this.$route.params.companySlug
      this.handleMounted()
      next()
   },
}
</script>
